export function getBrowserInfo(): string {
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const screenWidth = screen.width;
    const screenHeight = screen.height;
    const devicePixelRatio = window.devicePixelRatio;
    const userAgent = navigator.userAgent;
    const language = navigator.language;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const browser = getBrowserNameAndVersion(userAgent);

    const features = [
        `WebSocket=${"WebSocket" in window}`,
        `WebRTC=${"RTCPeerConnection" in window}`,
        `LocalStorage=${"localStorage" in window}`,
        `ServiceWorker=${"serviceWorker" in navigator}`,
        `Notifications=${"Notification" in window}`,
        `Geolocation=${"geolocation" in navigator}`,
    ];

    return [
        `Viewport=${viewportWidth}x${viewportHeight}`,
        `Screen=${screenWidth}x${screenHeight}`,
        `DevicePixelRatio=${devicePixelRatio}`,
        `Language=${language}`,
        `TimeZone=${timezone}`,
        `Browser=${browser}`,
        ...features,
    ].join(", ");
}

function getBrowserNameAndVersion(userAgent: string): string {
    const ua = userAgent;

    const browserMatchers: { regex: RegExp; name: string }[] = [
        { regex: /Edg\/(\d+)/, name: "Edge" },
        { regex: /Chrome\/(\d+)/, name: "Chrome" },
        { regex: /Firefox\/(\d+)/, name: "Firefox" },
        { regex: /Safari\/(\d+)/, name: "Safari" },
        { regex: /OPR\/(\d+)/, name: "Opera" },
    ];

    for (const matcher of browserMatchers) {
        const match = matcher.regex.exec(ua);
        if (match) {
            return `${matcher.name} ${match[1]}`;
        }
    }

    return "Unknown";
}
